import * as React from 'react';

import * as styles from './BannersRow.css';
import { LayoutBlock } from '../LayoutBlock';

export const BannersRow: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <LayoutBlock data-testid="BannersRow">
      <div className={styles['row']}>{children}</div>
    </LayoutBlock>
  );
};
